/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q3_QuestionInputs */

const en_faq_q3_question = /** @type {(inputs: Faq_Q3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does my insurance provide coverage outside my province or outside Canada?`)
};

const fr_faq_q3_question = /** @type {(inputs: Faq_Q3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon assurance offre-t-elle une couverture à l'extérieur de ma province ou du Canada ?`)
};

/**
* | output |
* | --- |
* | "Does my insurance provide coverage outside my province or outside Canada?" |
*
* @param {Faq_Q3_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q3_question = /** @type {((inputs?: Faq_Q3_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q3_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q3_question(inputs)
	return fr_faq_q3_question(inputs)
});